import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-ml-2 p-p-2 p-component" }
const _hoisted_2 = { class: "header p-component" }
const _hoisted_3 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('Squeeze.Reports.Reset')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resets, (resetOption) => {
      return (_openBlock(), _createElementBlock("div", {
        key: resetOption.key,
        class: "flex align-items-center p-p-2"
      }, [
        _createVNode(_component_Checkbox, {
          modelValue: _ctx.selectedResets,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedResets) = $event)),
          inputId: resetOption.key,
          value: resetOption.name
        }, null, 8, ["modelValue", "inputId", "value"]),
        _createElementVNode("label", {
          for: resetOption.name,
          class: "p-pl-2"
        }, _toDisplayString(resetOption.name) + " (" + _toDisplayString(resetOption.description) + ") ", 9, _hoisted_3)
      ]))
    }), 128)),
    _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_Button, {
      type: "button",
      label: _ctx.$t('Squeeze.Reports.Reset'),
      icon: "mdi mdi-refresh",
      onClick: _ctx.runReset,
      disabled: _ctx.loading || !_ctx.selectedResets.length
    }, null, 8, ["label", "onClick", "disabled"])
  ]))
}